import React, { useState, useEffect } from 'react'
import api from '../components/api'
import DatePicker from "react-datepicker";
import MaskedInput from 'react-maskedinput';
import moment from 'moment'
import { registerLocale } from  "react-datepicker";
import ptBR from 'date-fns/locale/pt-BR';

import "react-datepicker/dist/react-datepicker.css";


registerLocale('ptBR', ptBR);


const Modal = (props) => {

    
    var ocorrencia_id = props.ocorrencia_id
    var adesao_institucional_id = props.adesao_institucional_id


    var [data, setData] = useState('')
    var [titulo, setTitulo] = useState('')
    var [texto, setTexto] = useState('')
    var [tipoOcorrencia_id, setTipoOcorrencia_id] = useState()

    var [resultadoTiposOcorrencias, setResultadoTiposOcorrencias] = useState()
    
    var ad_usr = sessionStorage.getItem('us_codigo')
    var [autor, setAutor] = useState(sessionStorage.getItem('nome'))

    /*

    data: Joi.date().required(),
    adesao_institucional_id: Joi.number().integer().required(),
    titulo: Joi.string().required().max(1000),
    texto: Joi.string().required(),
    tipoOcorrencia_id: Joi.number().integer().required(),
    ad_usr: Joi.number().integer().required(),

    */


    async function carregaTiposOcorrencias() {


        await api.get('tipoOcorrencia').then((result) => {

            setResultadoTiposOcorrencias(result.data.map((rs) =>
            
                <option value={rs.tipoOcorrencia_id}>{rs.tipoOcorrencia_descri}</option>
            ))

        }).catch((err) => {

            console.log(err.response)

        })


    }


    function carrega() {

        

        setTipoOcorrencia_id('')
        setTitulo('')
        setTexto('')
        setData('')
        
        setAutor(sessionStorage.getItem('nome'))

        if (!isNaN(ocorrencia_id)) {

            api.get(`ocorrencia/${ocorrencia_id}`).then((result) => {

                console.log(result.data)

                var dataR = result.data[0]

                //console.log(dataR.data.date.format())
                //var dataRegistro = new Date(dataR.data)
                var dateParts = dataR.data.split("/");
                var dataRegistro = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
                

                setTipoOcorrencia_id(dataR.tipoOcorrencia_id)
                setTitulo(dataR.titulo)
                setTexto(dataR.texto)
                setData(dataRegistro)
                setAutor(dataR.us_nome)

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }



    function salvaOcorrencia() {


        if (titulo == '') {

            window.toastr.error('<b>Título/Assunto</b> não pode ficar em branco!')
            return false

        }

        if (texto == '') {

            window.toastr.error('<b>Texto</b> não pode ficar em branco!')
            return false

        }

        if (tipoOcorrencia_id == null || tipoOcorrencia_id == '') {

            window.toastr.error('<b>Tipo de ocorrência</b> não pode ficar em branco!')
            return false

        }

        // convert data

        var novaData = moment(data).utc().format('YYYY-MM-DD')

        //console.log(novaData)

        //var data_array = data.split('/')
        //var dataF = `${data_array[2]}-${data_array[1]}-${data_array[0]}`


        var dataPost = {

            titulo: titulo,
            texto: texto,
            ad_usr: ad_usr,
            data: novaData,
            adesao_institucional_id: adesao_institucional_id,
            tipoOcorrencia_id: tipoOcorrencia_id,

        }

        //console.log(dataPost)
        //return false

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)
    
                    if (!isNaN(ocorrencia_id)) {


                        api.put(`ocorrencia/${ocorrencia_id}`, dataPost).then((response) => {

                            //console.log(response.data)
                            window.toastr.success('Registro salvo com sucesso!')
                            props.ocorrencias()
                            
    
                        }).catch((err) => {
                            console.log(err.response)
                        })


                    } else {

                        api.post('ocorrencia', dataPost).then((response) => {

                            console.log(response.data)
                            window.toastr.success('Registro salvo com sucesso!')
                            window.$("#modalOcorrencia").modal('hide');
                            props.ocorrencias()
                            props.carregaTotais()

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    }

                   

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    function apagaOcorrencia() {



        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)


                    api.delete(`ocorrencia/${ocorrencia_id}/${ad_usr}`).then((response) => {

                        console.log(response.data)
                        window.toastr.success('Apagado com sucesso!')
                        window.$("#modalOcorrencia").modal('hide');
                        props.ocorrencias()
                        props.carregaTotais()

                    }).catch((err) => {
                        console.log(err.response)
                    })

                

                

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    


    useEffect(() => {


        carrega()
        carregaTiposOcorrencias()


    }, [ocorrencia_id])


    return (

        <div>


                <div className="modal fade" id="modalOcorrencia" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Ocorrência</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div className="panel-body">
                                        
                                        <div className="col-md-3">
                                            <div class="form-group">
                                                <label>Data</label>
                                                <DatePicker selected={data} onChange={(date) => setData(date)} className="form-control" locale="ptBR" dateFormat="dd/MM/yyyy" placeHolder="DD/MM/AAAA"
                                                customInput={
                                                    <MaskedInput mask="11/11/1111" placeholder="mm/dd/yyyy" />
                                                  } />
                                                                
                                            </div>
                                        </div>
                                        <div className="col-md-9">
                                            <div class="form-group">
                                                <label>Tipo</label>
                                                <select value={tipoOcorrencia_id} onChange={event => setTipoOcorrencia_id(event.target.value)} className="form-control">
                                                    <option value="">[Selecione]</option>
                                                    {resultadoTiposOcorrencias}
                                                </select>
                                                                
                                            </div>
                                        </div>

                                        <div className="col-md-8">
                                            <div class="form-group">
                                                <label>Título/Assunto</label>
                                                <input type="text" value={titulo} onChange={event => setTitulo(event.target.value)} className="form-control" placeholder="" maxLength={1000} />
                                                                
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div class="form-group">
                                                <label>Por</label>
                                                <input type="text" value={autor} className="form-control" readOnly tabIndex={-1} />
                                                                
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div class="form-group">
                                                <label>Texto</label>
                                                <textarea type="text" value={texto} rows="10" onChange={event => setTexto(event.target.value)} className="form-control" placeholder="" />
                                                                
                                            </div>
                                        </div>

                                      

                                    </div>


                            </div>
                            <div className="modal-footer">

                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                <button type="button" className="btn btn-danger" onClick={() => apagaOcorrencia()} style={{ display: !isNaN(ocorrencia_id) ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salvaOcorrencia()}>Salvar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>

        </div>


    )



}


    

export default Modal